import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Divider,
  FormControlLabel,
  Checkbox,
  Slider,
  Button
} from '@mui/material';
import axiosInstance from '../common/axios';

const FilterSidebar = ({ filters, setFilters, onApplyFilters }) => {
  const [availableBrands, setAvailableBrands] = useState([]);

  useEffect(() => {
    // Load filter options dynamically from the backend
    axiosInstance.get('/api/brands').then((res) => {
      setAvailableBrands(res.data);
    });
  }, []);

  // Corrected function to toggle brands
  const handleBrandToggle = (name) => {
    setFilters((prev) => {
      // The issue was here: prev.brands.filter((name) => name !== name)
      // Corrected to use a different parameter name, 'brandName'
      const newBrands = prev.brands.includes(name)
        ? prev.brands.filter((brandName) => brandName !== name)
        : [...prev.brands, name];
      return { ...prev, brands: newBrands };
    });
  };
  
  const handlePriceChange = (event, newValue) => {
    setFilters((prev) => ({ ...prev, priceRange: newValue }));
  };

  return (
    <Box
      sx={{
        p: 2,
        borderRight: '1px solid #ddd',
        backgroundColor: '#fafafa',
    
      }}
    >
      <Typography variant="subtitle1" sx={{fontWeight: 'bold' }}>Filters</Typography>
      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle4"  sx={{fontWeight: 'bold' }}>Brands</Typography>
     {availableBrands.map((brand) => (
  <FormControlLabel
    key={brand.name}
    control={
      <Checkbox size="micro" 
        checked={filters.brands.includes(brand.name)}
        onChange={() => handleBrandToggle(brand.name)}
      />
    }
    label={brand.name} // ✅ Show brand name instead of whole object
  />
))}

      <Divider sx={{ my: 2 }} />
      <Typography variant="subtitle4"  sx={{fontWeight: 'bold' }}>Price Range</Typography>
      <Slider
        value={filters.priceRange}
        onChange={handlePriceChange}
        valueLabelDisplay="auto"
        min={0}
        max={5000}
        sx={{ mt: 2 }}
      />

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 3 }}
        onClick={onApplyFilters}
      >
        Apply Filters
      </Button>
    </Box>
  );
};

export default FilterSidebar;